


function stripHtml(html) {
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || div.innerText || "";
}



  export async function translate (qq, source = 'EN', target) {

    const q = stripHtml(qq);

    const response = await fetch(process.env.VUE_APP_LIBRETRANSLATE_API , {
        method: "POST",
        body: JSON.stringify({
          q,
          source,
          target,
        }),
        headers: { "Content-Type": "application/json" },
      });

      if (!response.ok) {
        throw new Error('Errore HTTP: ' + response.status);
      }
  
      return await response.json();
  }